import { HStack, View, VStack } from "native-base";
import React, { useEffect, useRef, useState } from "react";
import {
  KeyboardAvoidingView,
  ScrollView,
  StyleSheet,
  TouchableWithoutFeedback,
} from "react-native";
import {
  faEye,
  faEyeSlash,
  faInfoCircle,
  faLockAlt,
  faTabletAndroidAlt,
  faTimes,
  faUserAlt,
} from "../../assets/consts/faCharCodes";
import Theme from "../argon-ui/Theme";
import Text from "../components_v2/TextFont";
import { IS_WEB, translate } from "../locales/translate";
import InputBase from "../nativeBase-ui/InputBase";
import MultiSelect from "react-native-multiple-select";
import { useDispatch, useSelector } from "react-redux";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { ArButton } from "../argon-ui";
import {
  addTouchPanel,
  clearNewTouchPanel,
  updateTouchPanel,
} from "../actions/DeviceActions";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import { getIsRTL } from "../util";

type Props = {
  navigation: any;
};

type areaSelectModel = {
  areaName: string;
  areaUId: string;
};
type errorHandleModel = {
  hasError: boolean;
  errorMessage: string;
};
const TouchPanelFormScreen = (props: Props) => {
  const ref = useRef<any>(null);
  // === Redux ===
  const dispatch = useDispatch();
  const accessToken = useSelector(
    (state: any) => state.AppReducer.currentServer?.accessToken
  );
  const areas = useSelector((state: any) => state.AreaReducer.areas);
  const devices = useSelector((state: any) => state.DeviceReducer.list);
  const newTouchPanel = useSelector(
    (state: any) => state.DeviceReducer.newTouchPanel
  );

  // === props ===
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [showChangePasswordFields, setShowChangePasswordFields] =
    useState<boolean>(true);

  const [loading, setLoading] = useState<boolean>(false);

  const [deviceId, setDeviceId] = useState<number | undefined | null>(0);
  const [deviceUId, setDeviceUId] = useState<string | undefined | null>(null);
  const [deviceType, setDeviceType] = useState<string | undefined | null>(null);
  const [deviceName, setDeviceName] = useState<string>("");
  const [username, setUsername] = useState<string>(""); // show edit form and just readOnly
  const [deviceModel, setDeviceModel] = useState<string>(""); //optional
  const [deviceVersion, setDeviceVersion] = useState<string>(""); //optional
  // === password handler ===
  const [password, setPassword] = useState("");
  const [passwordConfirm, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  // === error handle ===
  const [deviceNameError, setDeviceNameError] = useState<errorHandleModel>({
    hasError: false,
    errorMessage: "",
  });
  const [areaListError, setAreaListError] = useState<errorHandleModel>({
    hasError: false,
    errorMessage: "",
  });
  const [passwordError, setPasswordError] = useState<errorHandleModel>({
    hasError: false,
    errorMessage: "",
  });
  const [passwordConfirmError, setPasswordConfirmError] =
    useState<errorHandleModel>({
      hasError: false,
      errorMessage: "",
    });

  // === area list for multiSelected ===
  const [areaList, setAreaList] = useState<areaSelectModel[]>([]);
  const [selectArea, setSelectArea] = useState<string[]>([]);

  // === Methods ===
  const onSelectedItemsChange = (selectedItems: any) => {
    setAreaListError({
      hasError: false,
      errorMessage: "",
    });
    setSelectArea(selectedItems);
  };
  // === find areas from areaReducer ===
  useEffect(() => {
    if (
      props.navigation.state.params?.deviceId ||
      props.navigation.state.params?.deviceUId
    ) {
      setDeviceId(props.navigation.state.params?.deviceId);
      setDeviceUId(props.navigation.state.params?.deviceUId);
      const findDevice = devices?.find(
        (device: any) =>
          device.deviceId == props.navigation.state.params?.deviceId ||
          device.deviceUId === props.navigation.state.params?.deviceUId
      );
      if (findDevice) {
        const { deviceName, model, version, userName, password, deviceType } =
          findDevice;
        setIsEdit(true);
        setShowChangePasswordFields(false);
        setDeviceName(deviceName);
        setUsername(userName);
        setDeviceModel(model);
        setDeviceVersion(version);
        setPassword(password);
        setConfirmPassword(password);
        // setSelectArea(areaUIds);
        setDeviceType(deviceType);
      }
    }
    const areaList = areas?.map((area: any) => {
      const areaModel: areaSelectModel = {
        areaName: area.areaName,
        areaUId: area.areaUId,
      };
      return areaModel;
    });
    setAreaList(areaList);
  }, []);

  const goBack = () => {
    if (props.navigation) {
      // go back to prev screen
      props.navigation.goBack();

      // callback
      props.navigation.state.params.onGoBack &&
        props.navigation.state.params.onGoBack(deviceType);

      return false;
    }
  };
  const save = () => {
    let isValid = true;
    var model = {
      deviceId,
      id: deviceUId,
      deviceName,
      areaUIds: selectArea,
      model: deviceModel,
      version: deviceVersion,
      password,
      passwordConfirm,
    };
    // validation
    if (!model.deviceName) {
      isValid = false;
      setDeviceNameError({
        hasError: true,
        errorMessage: `${translate("device.deviceName")} ${translate(
          "app.isRequired"
        )}`,
      });
    }
    if (!isEdit && model.areaUIds.length == 0) {
      isValid = false;
      setAreaListError({
        hasError: true,
        errorMessage: `${translate("touchPanel.errors.selectAreas")}`,
      });
    }
    if (
      (isEdit ? model.password && model.password.length !== 0 : true) &&
      model.password.length < 4
    ) {
      isValid = false;
      setPasswordError({
        hasError: true,
        errorMessage: `${translate("touchPanel.errors.passwordIsRequired")}`,
      });
    }
    if (
      (isEdit ? model.password && model.password !== passwordConfirm : true) &&
      model.password !== passwordConfirm
    ) {
      isValid = false;
      setPasswordConfirmError({
        hasError: true,
        errorMessage: `${translate("touchPanel.errors.passwordConfirmError")}`,
      });
    }

    if (!isValid) {
      return;
    }
    // console.log("model", model);
    // if valid
    if (accessToken) {
      if (isEdit) {
        dispatch(updateTouchPanel(model, accessToken));
        goBack();
      } else {
        setLoading(true);
        dispatch(addTouchPanel(model, accessToken));
      }
    }
    // goBack();
  };
  const renderSelectedArea = (areaSelect: string | number, i: number) => {
    const findAreaSelected = areaList.find(
      (item) => item.areaUId == areaSelect
    );
    const removeHandler = () => {
      const filterItem: string[] = selectArea.filter(
        (item: string) => item !== areaSelect
      );
      setSelectArea(filterItem);
    };
    return (
      <TouchableWithoutFeedback onPress={removeHandler} key={i}>
        <HStack space="2" style={style.areaSelectBadge} alignItems="center">
          <FontAwesomeIcon
            icon={faTimes}
            size={12}
            color={Theme.COLORS.ERROR}
          />
          <Text style={{ fontSize: 12 }}>{findAreaSelected?.areaName}</Text>
        </HStack>
      </TouchableWithoutFeedback>
    );
  };

  return (
    <>
      <KeyboardAvoidingView
        behavior="height"
        style={{ flex: 1 }}
        enabled={true}
        keyboardVerticalOffset={80}
      >
        <ScrollView style={style.container}>
          {/* === device Name === */}
          <Text style={style.screenTitle}>
            {deviceName ? deviceName : translate("touchPanel.touchPanel")}
          </Text>
          <VStack space="3">
            {/* === device Name === */}
            <InputBase
              showSubInput={true}
              isInvalid={deviceNameError.hasError}
              errorMessage={deviceNameError.errorMessage}
              label={translate("device.deviceName")}
              placeholder={translate("touchPanel.touchPanel")}
              onChangeText={(txt: string) => {
                setDeviceNameError({ hasError: false, errorMessage: "" });
                setDeviceName(txt);
              }}
              value={deviceName}
              icon={faTabletAndroidAlt}
            />

            {/* === area multiSelect === */}
            <View style={{ flex: 1, marginBottom: 5, marginTop: 5 }}>
              {/* <Text
              Text
              style={[
                {
                  color: Theme.COLORS.GRAY_DARK,
                  fontSize: 14,
                  paddingRight: 16,
                  marginBottom: 20,
                },
              ]}
            >
              {translate("touchPanel.selectAreas")}
            </Text> */}
              {!isEdit && (
                <MultiSelect
                  ref={ref}
                  hideTags
                  items={areaList}
                  uniqueKey="areaUId"
                  displayKey="areaName"
                  styleDropdownMenuSubsection={[
                    {
                      borderRadius: 10,
                      height: 50,
                    },
                    !IS_WEB && { paddingLeft: 20, paddingRight: 5 },
                  ]}
                  // ref={(component) => {
                  //   ref = component;
                  // }}
                  onSelectedItemsChange={onSelectedItemsChange}
                  selectedItems={selectArea}
                  selectText={translate("touchPanel.selectAreas")}
                  searchInputPlaceholderText={translate("app.search")}
                  // onChangeInput={(text) => console.log(text)}
                  altFontFamily="IRANSansWebFaNum"
                  itemFontFamily="IRANSansWebFaNum"
                  selectedItemFontFamily="IRANSansWebFaNum"
                  selectedItemTextColor="#CCC"
                  selectedItemIconColor="#CCC"
                  itemTextColor="#000"
                  searchInputStyle={{
                    color: "#CCC",
                    borderRadius: 10,
                    height: 40,
                    borderColor: "transparent",
                    textAlign: getIsRTL() ? "right" : "left",
                    fontFamily: "IRANSansWebFaNum",
                  }}
                  selectedText={translate("touchPanel.selectedText")}
                  submitButtonText={translate("app.select")}
                  submitButtonColor={Theme.COLORS.PRIMARY}
                />
              )}
              {/* <View>{ref.getSelectedItemsExt(selectArea)}</View> */}
              <HStack space="2" alignItems="center">
                {selectArea.map((item, i) => renderSelectedArea(item, i))}
              </HStack>
              {/* === error handler === */}
              <View style={{ alignItems: "center", flexDirection: "row" }}>
                {areaListError.hasError && (
                  <FontAwesomeIcon
                    style={{ paddingHorizontal: 4 }}
                    icon={faInfoCircle}
                    size={15}
                    color={Theme.COLORS.ERROR}
                  />
                )}
                <Text style={{ color: Theme.COLORS.ERROR, fontSize: 12 }}>
                  {areaListError.errorMessage}
                </Text>
              </View>
            </View>

            {/* === User Name  show edit form and readOnly === */}
            {(deviceId || deviceUId) && (
              <InputBase
                editable={false}
                label={translate("touchPanel.userName")}
                onChangeText={(txt: string) => setUsername(txt)}
                value={username}
                icon={faUserAlt}
              />
            )}
            {/* === show password field just add form === */}
            {isEdit && (
              <Text
                style={{
                  color: Theme.COLORS.PRIMARY,
                  marginTop: 20,
                  marginHorizontal: 10,
                }}
                onPress={() => {
                  setShowChangePasswordFields(!showChangePasswordFields);
                }}
              >
                {translate("login.resetPasswordHeading")}
              </Text>
            )}
            {showChangePasswordFields && (
              <>
                {/*  === Password === */}
                <InputBase
                  showSubInput={true}
                  isInvalid={passwordError.hasError}
                  errorMessage={passwordError.errorMessage}
                  value={password}
                  placeholder={translate("login.password")}
                  onChangeText={(password: string) => {
                    setPasswordError({ hasError: false, errorMessage: "" });
                    setPassword(password);
                  }}
                  secureTextEntry={!showPassword}
                  icon={faLockAlt}
                  iconLeft={
                    <TouchableWithoutFeedback
                      onPress={() => setShowPassword(!showPassword)}
                    >
                      <View
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                          paddingHorizontal: 14,
                        }}
                      >
                        <FontAwesomeIcon
                          icon={showPassword ? faEyeSlash : faEye}
                          color={Theme.COLORS.MUTED}
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  }
                />
                {/*  === passwordConfirm ===  */}
                <InputBase
                  showSubInput={true}
                  isInvalid={passwordConfirmError.hasError}
                  errorMessage={passwordConfirmError.errorMessage}
                  value={passwordConfirm}
                  placeholder={translate("login.confirmPassword")}
                  onChangeText={(passwordConfirm: string) => {
                    setPasswordConfirmError({
                      hasError: false,
                      errorMessage: "",
                    });
                    setConfirmPassword(passwordConfirm);
                  }}
                  secureTextEntry={!showPasswordConfirm}
                  icon={faLockAlt}
                  iconLeft={
                    <TouchableWithoutFeedback
                      onPress={() =>
                        setShowPasswordConfirm(!showPasswordConfirm)
                      }
                    >
                      <View
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                          paddingHorizontal: 14,
                        }}
                      >
                        <FontAwesomeIcon
                          icon={showPasswordConfirm ? faEyeSlash : faEye}
                          color={Theme.COLORS.MUTED}
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  }
                />
              </>
            )}

            {/* === device Model (Optional) === */}
            <InputBase
              // isInvalid={this.state.validation_deviceName_hasError}
              label={translate("touchPanel.deviceModel")}
              placeholder={translate("touchPanel.deviceModelPlaceholder")}
              onChangeText={(txt: string) => setDeviceModel(txt)}
              value={deviceModel}
              icon={faInfoCircle}
            />

            {/* === device version (Optional)=== */}
            <InputBase
              // isInvalid={this.state.validation_deviceName_hasError}
              label={translate("touchPanel.deviceVersion")}
              placeholder={translate("touchPanel.deviceVersionPlaceholder")}
              onChangeText={(txt: string) => setDeviceVersion(txt)}
              value={deviceVersion}
              icon={faInfoCircle}
            />
          </VStack>
          <HStack space={2} style={{ marginVertical: 10 }}>
            <ArButton
              color="primary"
              isLoading={loading}
              onPress={() => save()}
              style={[{ flex: 1 }, !IS_WEB && { marginBottom: 25 }]}
            >
              {translate("app.save")}
            </ArButton>
            <ArButton
              color="muted"
              variant="outline"
              onPress={() => goBack()}
              style={{ flex: 1 }}
            >
              {translate("app.goBack")}
            </ArButton>
          </HStack>
        </ScrollView>
      </KeyboardAvoidingView>
      {/* === show password nad new UserName after create device === */}
      {newTouchPanel && (
        <AlertDialogBase
          cancelBtn={false}
          isOpen={newTouchPanel}
          title={translate("touchPanel.successMessageAddDeviceTitle")}
          confirmText={translate("app.confirm")}
          colorConfirm="primary"
          confirmHandler={() => {
            goBack();
            dispatch(clearNewTouchPanel());
          }}
          onClose={() => {
            goBack();
            dispatch(clearNewTouchPanel());
          }}
        >
          <>
            <Text style={{ fontSize: 12 }}>
              {translate("touchPanel.successMessageAddDevice", {
                password,
                username: newTouchPanel.userName || "",
              })}
            </Text>
            <Text style={{ color: Theme.COLORS.ERROR }}>
              {translate("touchPanel.successMessageAddDeviceAlert")}
            </Text>
          </>
        </AlertDialogBase>
      )}
    </>
  );
};
const style = StyleSheet.create({
  container: {
    paddingTop: 20,
    paddingHorizontal: 10,
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
  },
  inputLabel: {
    fontWeight: "500",
    fontSize: 15.4,
    marginBottom: 4,
  },
  CheckBox: {
    alignSelf: "center",
    padding: 0,
    margin: 0,
    width: 16,
  },
  areaSelectBadge: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 10,
    backgroundColor: Theme.COLORS.WHITE,
  },
});
TouchPanelFormScreen["navigationOptions"] = ({
  screenProps: { translate },
}: any) => ({
  headerTitle: translate("navigation.touchPanel"),
});
export default TouchPanelFormScreen;
